<button mat-button class="ribbon-button-padding">
    <mat-icon [class]="theme.myDialogIconBgColor">close</mat-icon>     
</button>
